import React from 'react';
import { SlotMachineValue } from './SlotMachineValue';
import { Button, Message, PointBadge, PointValue } from './RewardCta.styles';

export interface RewardCtaProps {
  /** 포인트 배지 글자 ("P") */
  pointLabel: string;
  /** 포인트 값 ("20") */
  pointValue: string;
  /** 보상 메시지 ("게이지 리워드 획득") */
  message: string;
  /** true면 포인트 숫자를 슬롯머신처럼 굴린 뒤 pointValue에 멈춘다 */
  animatePointValue?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

/**
 * 리워드 획득 CTA (feature)
 * - 초록 버튼 + 포인트 토스트 라벨("🅟 20 게이지 리워드 획득").
 * - 출처: 스펙 §1-5. hover/pressed/disabled 미정의 → 표준값 적용(디자이너 확인 §4).
 */
export function RewardCta({
  pointLabel,
  pointValue,
  message,
  animatePointValue = false,
  onClick,
  disabled = false,
}: RewardCtaProps) {
  return (
    <Button type="button" onClick={onClick} disabled={disabled}>
      <PointBadge aria-hidden="true">{pointLabel}</PointBadge>
      <PointValue>
        <SlotMachineValue value={pointValue} active={animatePointValue} />
      </PointValue>
      <Message>{message}</Message>
    </Button>
  );
}
